import { render } from "./StandardTrainings.vue?vue&type=template&id=2668a094&scoped=true"
import script from "./StandardTrainings.vue?vue&type=script&lang=js"
export * from "./StandardTrainings.vue?vue&type=script&lang=js"

import "./StandardTrainings.vue?vue&type=style&index=0&id=2668a094&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2668a094"]])

export default __exports__